var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavOffersMegafone = function SvgNavOffersMegafone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nav_offers_megafone_svg__Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nav_offers_megafone_svg__st0{fill:#666}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_offers_megafone_svg___1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_megafone_svg__st0",
    d: "M30.4 29.7h-2.8c-1.9 0-3.4-1.5-3.4-3.4v-6.6c0-1.9 1.5-3.4 3.4-3.4h2.8c.4 0 .7.3.7.7v12c0 .4-.3.7-.7.7zm-2.7-12c-1.1 0-2 .9-2 2v6.6c0 1.1.9 2 2 2h2.1V17.7h-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_megafone_svg__st0",
    d: "M25.2 28.2h-5.5c-2.3 0-4.2-1.9-4.2-4.2v-2c0-2.3 1.9-4.2 4.2-4.2h5.5c.4 0 .7.3.7.7 0 .4-.3.7-.7.7h-5.5c-1.6 0-2.8 1.3-2.8 2.8v2c0 1.6 1.3 2.8 2.8 2.8h5.5c.4 0 .7.3.7.7s-.3.7-.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_megafone_svg__st0",
    d: "M22.1 33.2c-1 0-1.9-.7-2.1-1.7l-.8-3.8c-.1-.4.2-.8.5-.8.4-.1.8.2.8.5l.8 3.8c.1.4.5.7.9.6.4-.1.7-.5.6-.9l-.7-3.2c-.1-.4.2-.8.5-.8.4-.1.8.2.8.5l.7 3.2c.2 1.2-.5 2.3-1.7 2.5 0 .1-.2.1-.3.1zM30.4 26.8c-.4 0-.7-.3-.7-.7s.3-.7.7-.7c1.3 0 2.4-1.1 2.4-2.4 0-1.3-1.1-2.4-2.4-2.4-.4 0-.7-.3-.7-.7s.3-.7.7-.7c2.1 0 3.8 1.7 3.8 3.8s-1.6 3.8-3.8 3.8z"
  }))));
};
export default SvgNavOffersMegafone;